import { useAppI18N } from '@/app'
import { View, Text, Button } from '@/components'
import { modal } from '@codeleap/modals'

export const ContributeSizeAlert = modal()
  .content(props => {
    const { toggle } = props

    const { t } = useAppI18N()

    return (
      <View variants={['column', 'gap:2', 'center']}>
        <Text variants={['h4', 'color:neutral10']} text={t('hurdle.contribute.videoTooLarge.title')} />
        <Text variants={['p1', 'textCenter']} text={t('hurdle.contribute.videoTooLarge.body')} />
        <Button
          onPress={toggle}
          text={t('hurdle.contribute.videoTooLarge.ok')}
          debugName={'video too large alert ok'}
          variants={['destructive', 'fullWidth']}
        />
      </View>
    )
  })
  .props({ variants: ['centered'], showClose: false })
